/// <reference path="../../../.tmp/typings/tsd.d.ts" />
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ModalBody;
ModalBody.$inject = ['currentlyOpenModals'];
function ModalBody(currentlyOpenModals) {
    return {
        restrict: 'E',
        link: function (scope, element) {
            scope.$watch(function () { return !!currentlyOpenModals.openModals.length; }, function (modalOpen) {
                if (modalOpen) {
                    element.addClass('modal-open');
                }
                else {
                    element.removeClass('modal-open');
                }
            });
        }
    };
}



//////////////////
// WEBPACK FOOTER
// ./src/components/base/modalbody.directive.ts
// module id = 5
// module chunks = 0